import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
`;

export default Wrapper;
